import { Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AppGeneralStateService } from 'src/app/app-general-state.service';

@Component({
  selector: 'app-error-banner',
  standalone: true,
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './error-banner.component.html',
  styleUrl: './error-banner.component.scss',
})
export class ErrorBannerComponent {
  displayText: string = 'Error Message Here';
  @Input()
  set ErrorMessage(value: string) {
    this.displayText = value;
  }

  #_appGeneralState = inject(AppGeneralStateService);

  closeErrorBanner() {}
}
